//@ts-ignore
import BaseFloatingLabel from "@vueEntry/UIKitComponents/BaseFloatingLabel.vue";
import { defineComponent } from "vue";
//TODO: da inserire questo componente in pagina lavora con noi!
export default defineComponent({
  name: "BaseUploadFile",
  components: {
    BaseFloatingLabel
  },
  inheritAttrs: false,
  props: {
    withMargin: {
      type: Boolean,
      default: true
    },
    labelText: {
      type: String,
      default: ""
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  emits: ["cleared", "uploaded"],
  data() {
    return {
      filename: ""
    };
  },
  watch: {
    clear(cur) {
      if (!cur) return;
      this.filename = "";
      this.$emit("cleared");
    }
  },
  methods: {
    handleInput(_ref) {
      var {
        target
      } = _ref;
      if (!target) return;
      var uploadedFile = target.files[0];
      this.filename = uploadedFile.name;
      this.$emit("uploaded", uploadedFile);
    }
  }
});